import GameCode from '../games/GameCode';

class CharacterIdentificationConditionsGroup {
    static serialize(characterIdentificationConditionsGroup) {
        const gameCode = characterIdentificationConditionsGroup.gameCode.wireName;
        const identificationNameOrVerificationNumber = characterIdentificationConditionsGroup.identificationNameOrVerificationNumber;

        return {
            gameCode,
            identificationNameOrVerificationNumber,
        };
    }

    static deserialize(jsonObj) {
        const gameCode = GameCode.valueOfWireName(jsonObj.gameCode);
        const identificationNameOrVerificationNumber = jsonObj.identificationNameOrVerificationNumber;

        return (new CharacterIdentificationConditionsGroup(gameCode, identificationNameOrVerificationNumber));
    }

    static clone(characterIdentificationConditionsGroup) {
        const jsonObj = this.serialize(characterIdentificationConditionsGroup);
        const clonedCharacterIdentificationConditionsGroup = this.deserialize(jsonObj);

        return clonedCharacterIdentificationConditionsGroup;
    }

    gameCode;
    identificationNameOrVerificationNumber;

    constructor(gameCode, identificationNameOrVerificationNumber) {
        this.gameCode = gameCode;
        this.identificationNameOrVerificationNumber = identificationNameOrVerificationNumber;
    }
}

export default CharacterIdentificationConditionsGroup;
